import { defineFakeRoute } from 'vite-plugin-fake-server/client';
import type { ServerSort } from '@/services/business/servers';
import { serverRegions } from '@/services/business/servers/types';
import { resultError, resultSuccess, routeParam } from '../business/utils';
import { gatewayServers } from './fixtures';
import registrationRoutes from './server-registration';
import { serverRegistrationFor } from './server-registration-store';

const statusRank = { offline: 0, unknown: 1, online: 2 };
const sortFields: ServerSort[] = ['name', 'status', 'lastReportedAt', 'cpu', 'memory'];
let detailFailurePending = true;
export default defineFakeRoute([
  {
    url: '/platform/servers',
    method: 'get',
    response: ({ query }) => {
      const page = Number(query.page ?? 1),
        pageSize = Number(query.page_size ?? 10);
      const sort = routeParam(query.sort) as ServerSort | undefined;
      const order = routeParam(query.order);
      const status = routeParam(query.status),
        region = routeParam(query.region);
      if (
        !Number.isInteger(page) ||
        page < 1 ||
        !Number.isInteger(pageSize) ||
        pageSize < 1 ||
        pageSize > 100 ||
        (sort !== undefined && !sortFields.includes(sort)) ||
        (order !== undefined && !['asc', 'desc'].includes(order)) ||
        !!sort !== !!order ||
        (status !== undefined && !['online', 'offline', 'unknown'].includes(status)) ||
        (region !== undefined && !serverRegions.some((value) => value === region))
      ) {
        return resultError('查询参数无效，请检查分页、筛选和排序条件', 422);
      }
      const q = (routeParam(query.q) ?? '').trim().toLowerCase();
      const items = gatewayServers
        .filter(
          (server) =>
            (!status || server.status === status) &&
            (!region || server.region === region) &&
            (!q ||
              [server.name, server.id, server.ip].some((value) =>
                value.toLowerCase().includes(q),
              )),
        )
        .sort((a, b) => {
          if (!sort)
            return (
              statusRank[a.status] - statusRank[b.status] ||
              a.name.localeCompare(b.name)
            );
          const av = sort === 'status' ? statusRank[a.status] : a[sort];
          const bv = sort === 'status' ? statusRank[b.status] : b[sort];
          if (av === null || bv === null)
            return av === bv ? a.id.localeCompare(b.id) : av === null ? 1 : -1;
          const comparison =
            typeof av === 'number' && typeof bv === 'number'
              ? av - bv
              : String(av).localeCompare(String(bv));
          return comparison * (order === 'desc' ? -1 : 1) || a.id.localeCompare(b.id);
        });
      return resultSuccess({
        items: items
          .slice((page - 1) * pageSize, page * pageSize)
          .map(({ instances: _instances, ...server }) => server),
        total: items.length,
        page,
        page_size: pageSize,
      });
    },
  },
  {
    url: '/platform/servers/:id',
    method: 'get',
    response: ({ params }) => {
      const id = routeParam(params.id);
      const server = gatewayServers.find((item) => item.id === id);
      if (!server) return resultError('服务器不存在或已移除', 404);
      // Repeatable recoverable-failure scenario; reset by a dev-server/module restart.
      if (id === 'srv-bj-02' && detailFailurePending) {
        detailFailurePending = false;
        return resultError('服务器详情查询超时，请重试', 504);
      }
      return resultSuccess({
        ...server,
        registration: serverRegistrationFor(server.id),
      });
    },
  },
  ...(Array.isArray(registrationRoutes) ? registrationRoutes : [registrationRoutes]),
]);
